import { h, Component } from 'preact'
import { Loader } from 'rendering/components/loader';

export class SmartCaptionsAnnotation extends Component {
    constructor(...args) {
        super(...args)
        this.loadAnnotation()
    }


    render() {
        const { props } = this; 
        const { loaded = false, SmartCaptions } = this.state;

        return(
            loaded ? 
                <SmartCaptions {...props}/> :
                <div>
                    <Loader />
                </div>
        )
    }

    loadAnnotation() {
        import(
            /* webpackChunkName: "smart-captions-annotation" */
            './smart_captions'
        )
        .then(({SmartCaptions}) => {
            this.setState({
                loaded: true,
                SmartCaptions
            });
        })
    }

    get loaderStyles() {
        const { styles = {} } = this.props;
        
        return {
            ...(styles['compositionTypes.root'] || {}),
            display: 'flex',
            justifyContent: 'center', 
            alightItems: 'center'
        }
    }

    static get composition() {
        return [];
    }

    static get schemaType () {
        return 'smartcaptions'
    }
}

export class AdjacentSmartCaptionsAnnotation extends SmartCaptionsAnnotation {
    static scalable = false

    loadAnnotation() {
        import(
            /* webpackChunkName: "adjacent-smart-captions-annotation" */
            './adjacent'
        )
        .then(({AdjacentSmartCaptions}) => {
            this.setState({
                loaded: true,
                SmartCaptions: AdjacentSmartCaptions
            });
        })
    }
}
